import { render, staticRenderFns } from "./commodityDetailsDialog.vue?vue&type=template&id=42e5193c&scoped=true&"
import script from "./commodityDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./commodityDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./commodityDetailsDialog.vue?vue&type=style&index=0&id=42e5193c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e5193c",
  null
  
)

export default component.exports